
if (window.innerWidth < 460) {

    let form_elem = document.getElementById("form-anchor");

    const hideBtn = (e) => {
        console.log(e);
        let btn = document.getElementById("scroll-btn");
        if (!e[0].isIntersecting){
            btn.style.display = "block";
        }
        if (e[0].isIntersecting){
            btn.style.display = "none";
        }
    }

    const hideBtnIntersectionObs = new IntersectionObserver(hideBtn);
    hideBtnIntersectionObs.observe(form_elem);
    }